<template>
  <v-footer
          id="core-footer"
          absolute
  >
    <div class="footer-items">
      <span
              v-for="link in links"
              :key="link.name"
      >
        <a
                :href="link.Link"
                class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      {{$t('Core.Footer.made_by')}}
      <a
              href="javascript:{}"
              target="_blank">2xD Team</a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: []
  }),
  mounted(){
    this.links = [
        { name: this.$t('Core.Footer.home'), Link: '/dashboard' },
    ]
  }
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
